// 응답 코드
const RESPONSE_CODE = {
  Success: '000',
  Error: '999',
  ErrorDB: '998',
  ErrorNull: '997',
  ErrorUnknown: '996',
  BadRequestLogin: '200',
  NotFoundUser: '210',
  InvalidPassword: '220',
  DuplicateLogin: '230',
  ErrorLogin: '240',
  BadRequestInsert: '300',
  InvalidInsert: '301',
  DuplicateInsert: '302',
  BadRequestSearch: '400',
  ErrorSearch: '401',
  InvalidSearch: '402',
  NotFoundData: '403',
  BadRequestUpdate: '500',
  InvalidUpdate: '501',
  BadRequestDelete: '600',
  Unauthorized: '700',
  Forbidden: '701'
};

// 응답 코드별 메시지
const RESPONSE = {
  [RESPONSE_CODE.BadRequestLogin]: 'badRequest',
  [RESPONSE_CODE.InvalidPassword]: 'errorLoginMessage',
  [RESPONSE_CODE.ErrorLogin]: 'errorLoginMessage',
  [RESPONSE_CODE.BadRequestInsert]: 'badRequest',
  [RESPONSE_CODE.BadRequestSearch]: 'badRequest',
  [RESPONSE_CODE.NotFoundData]: 'notFoundData',
  [RESPONSE_CODE.BadRequestUpdate]: 'badRequest',
  [RESPONSE_CODE.BadRequestDelete]: 'badRequest',
  [RESPONSE_CODE.Unauthorized]: 'unauthorized',
  [RESPONSE_CODE.Forbidden]: 'forbidden',
  [RESPONSE_CODE.Error]: 'error',
  [RESPONSE_CODE.ErrorDB]: 'error',
  [RESPONSE_CODE.ErrorNull]: 'error',
  [RESPONSE_CODE.ErrorUnknown]: 'error'
};

// API URL
// TODO: API URL 통합 필요
const prependBaseURL = url => process.env.REACT_APP_API_URL.concat(url);
const API_URL = {
  common: {
    bu: prependBaseURL('/common/bu'),
    nation: prependBaseURL('/common/nation'),
    plant: {
      default: prependBaseURL('/common/plant'),
      foreign: prependBaseURL('/common/plant-foreign')
    }
  },
  category: prependBaseURL('/category/ctgryCd'),
  login: {
    default: prependBaseURL('/login'),
    valid: prependBaseURL('/login/valid')
  },
  sfms: {
    exchangeRate: {
      default: prependBaseURL('/sfms/exchange-rate'),
      inform: prependBaseURL('/sfms/exchange-rate/stats')
    },
    dashboard: {
      rawMaterial: {
        price: {
          statistic: prependBaseURL('/sfms/raw-material/price/mtril-stats'),
          export: prependBaseURL('/sfms/raw-material/price/transmit-stats'),
          trend: {
            default: prependBaseURL('/sfms/raw-material/price/stats'),
            stock: prependBaseURL('/sfms/raw-material/price/stock-stats')
          }
        }
      },
      product: {
        output: { trend: prependBaseURL('/sfms/product/outturn/stats') }
      },
      notice: prependBaseURL('/board/notice/dashboard')
    },
    rawMaterial: {
      price: {
        list: prependBaseURL('/sfms/raw-material/price'),
        download: prependBaseURL('/sfms/raw-material/price/form-download'),
        upload: {
          default: prependBaseURL('/sfms/raw-material/price/upload'),
          preview: prependBaseURL('/sfms/raw-material/price/upload-preview')
        },
        export: prependBaseURL('/sfms/raw-material/price/input-bestmix')
      },
      nutrition: {
        list: prependBaseURL('/sfms/raw-material/nutrition/info'),
        download: prependBaseURL('/sfms/raw-material/nutrition/form-download'),
        upload: prependBaseURL('/sfms/raw-material/nutrition/upload'),
        export: prependBaseURL('/sfms/raw-material/nutrition/input/bestmix')
      }
    },
    product: {
      output: {
        default: prependBaseURL('/sfms/product/outturn/info'),
        inform: prependBaseURL('/sfms/product/outturn/info/{seq}'),
        download: prependBaseURL('/sfms/product/outturn/form-download'),
        upload: prependBaseURL('/sfms/product/outturn/info/upload'),
        import: prependBaseURL('/sfms/product/outturn/import'),
        init: prependBaseURL('/sfms/product/outturn/reset')
      },
      nutrition: {
        list: prependBaseURL('/sfms/product/nutrition'),
        import: prependBaseURL('/sfms/product/nutrition/import')
      }
    },
    mix: {
      output: {
        list: prependBaseURL('/sfms/mix/production'),
        export: prependBaseURL('/sfms/mix/production/input-bestmix')
      },
      ratio: {
        list: prependBaseURL('/sfms/mix/ratio'),
        inform: prependBaseURL('/sfms/mix/ratio/{seq}'),
        download: {
          form: prependBaseURL('/sfms/mix/ratio/form-download'),
          sap: prependBaseURL('/sfms/mix/ratio/download')
        },
        upload: {
          default: prependBaseURL('/sfms/mix/ratio/upload'),
          preview: prependBaseURL('/sfms/mix/ratio/upload-preview')
        },
        export: prependBaseURL('/sfms/mix/ratio/input-sap'),
        init: prependBaseURL('/sfms/mix/ratio/initialization')
      }
    },
    report: {
      list: prependBaseURL('/sfms/report'),
      download: prependBaseURL('/sfms/report/download/{seq}'),
      mix: {
        plan: { insert: prependBaseURL('/sfms/report/mix-plan') },
        compare: { insert: prependBaseURL('/sfms/report/mix-perform') }
      },
      price: {
        rawMaterial: {
          insert: prependBaseURL('/sfms/report/raw-material-price')
        },
        product: { insert: prependBaseURL('/sfms/report/product-price') },
        prediction: { insert: prependBaseURL('/sfms/report/price-prediction') }
      },
      iomc: {
        insert: prependBaseURL('/sfms/raw-material/iomc/register'),
        inform: {
          default: prependBaseURL('/sfms/raw-material/iomc'),
          rmc: prependBaseURL('/sfms/raw-material/iomc/rmc')
        },
        calculate: prependBaseURL('/sfms/raw-material/iomc/calculate'),
        confirm: prependBaseURL('/sfms/raw-material/iomc/confirm'),
        cancel: prependBaseURL('/sfms/raw-material/iomc/cancel')
      },
      analysis: {
        product: { insert: prependBaseURL('/sfms/report/product-analysis') },
        quality: {
          rawMaterial: {
            insert: prependBaseURL('/sfms/report/rawmaterial-quality-analysis'),
            inform: prependBaseURL(
              '/sfms/report/rawmaterial-quality-analysis/search'
            ),
            analysis: prependBaseURL(
              '/sfms/report/rawmaterial-quality-analysis/detail'
            )
          },
          product: {
            insert: prependBaseURL('/sfms/report/product-quality-analysis'),
            inform: prependBaseURL(
              '/sfms/report/product-quality-analysis/search'
            ),
            analysis: prependBaseURL(
              '/sfms/report/product-quality-analysis/detail'
            )
          }
        }
      }
    }
  },
  board: {
    notice: {
      default: prependBaseURL('/board/notice'),
      inform: prependBaseURL('/board/notice/{seq}'),
      comment: {
        insert: prependBaseURL('/board/notice/{seq}/comment'),
        update: prependBaseURL('/board/notice/comment/{seq}')
      }
    },
    rawMaterial: {
      default: prependBaseURL('/sfms/raw-material/new'),
      inform: prependBaseURL('/sfms/raw-material/new/{seq}'),
      comment: {
        insert: prependBaseURL('/sfms/raw-material/new/comment'),
        update: prependBaseURL('/sfms/raw-material/new/comment/{seq}')
      },
      confirm: prependBaseURL('/sfms/raw-material/new/confirm/{seq}'),
      download: prependBaseURL('/sfms/raw-material/new/download/{seq}'),
      reject: prependBaseURL('/sfms/raw-material/new/reject/{seq}')
    },
    file: {
      default: prependBaseURL('/board/file'),
      delete: prependBaseURL('/board/file/attachment'),
      inform: prependBaseURL('/board/file/{seq}'),
      download: prependBaseURL('/board/file/download/{seq}')
    },
    qna: {
      default: prependBaseURL('/board/qna'),
      inform: prependBaseURL('/board/qna/{seq}'),
      comment: {
        insert: prependBaseURL('/board/qna/{seq}/comment'),
        update: prependBaseURL('/board/qna/comment/{seq}')
      }
    }
  },
  standard: {
    code: {
      default: prependBaseURL('/code'),
      inform: prependBaseURL('/code/{seq}'),
      mix: {
        default: prependBaseURL('/sfms/mix/info'),
        inform: prependBaseURL('/sfms/mix/info/{seq}'),
        download: prependBaseURL('/sfms/mix/info/form-download'),
        upload: prependBaseURL('/sfms/mix/info/upload')
      },
      rawMaterial: {
        list: prependBaseURL('/sfms/raw-material/info'),
        inform: prependBaseURL('/sfms/raw-material/info/{seq}')
      },
      product: {
        default: prependBaseURL('/sfms/product/info'),
        inform: prependBaseURL('/sfms/product/info/{seq}'),
        download: prependBaseURL('/sfms/product/info/form-download'),
        upload: prependBaseURL('/sfms/product/info/upload'),
        import: prependBaseURL('/sfms/product/info/import')
      }
    }
  },
  admin: {
    list: prependBaseURL('/admin'),
    insert: prependBaseURL('/admin/user'),
    inform: prependBaseURL('/admin/{seq}'),
    duplicate: prependBaseURL('/admin/user/duplicate')
  },
  user: {
    inform: prependBaseURL('/user/{seq}'),
    findPassword: prependBaseURL('/user/find/pwd'),
    valid: prependBaseURL('/user/verification')
  }
};

// 토큰 키
const TOKEN = 'X-AUTH-TOKEN';

// 라우터 경로
const ROUTER_PATH = {
  login: '/',
  sfms: {
    dashboard: {
      main: '/sfms/dashboard',
      trend: '/sfms/dashboard/trend'
    },
    rawMaterial: {
      price: '/sfms/raw-material/price',
      nutrition: '/sfms/raw-material/nutrition'
    },
    product: {
      output: '/sfms/product/output',
      nutrition: '/sfms/product/nutrition'
    },
    mix: {
      ratio: '/sfms/mix',
      output: '/sfms/mix/output'
    },
    monitoring: '/sfms/monitoring',
    report: {
      list: '/sfms/report/{type}',
      iomc: {
        setting: '/sfms/report/{type}/setting/{iomcYm}/{buCode}',
        inform: '/sfms/report/{type}/{iomcYm}/{buCode}/{seq}'
      },
      analysis: {
        quality: {
          rawMaterial:
            '/sfms/report/{type}/raw-material/{reportYm}/{factoryCodeSeq}/{seq}',
          product:
            '/sfms/report/{type}/product/{reportYm}/{factoryCodeSeq}/{seq}'
        }
      }
    }
  },
  board: {
    notice: {
      list: '/board/notice',
      setting: '/board/notice/setting/{seq}',
      inform: '/board/notice/{seq}'
    },
    rawMaterial: {
      list: '/board/raw-material',
      setting: '/board/raw-material/setting/{seq}',
      inform: '/board/raw-material/{seq}'
    },
    file: '/board/file',
    qna: {
      list: '/board/qna',
      setting: '/board/qna/setting/{seq}',
      inform: '/board/qna/{seq}'
    }
  },
  standard: {
    code: {
      default: '/standard/code',
      mix: '/standard/code/mix',
      rawMaterial: '/standard/code/raw-material',
      product: '/standard/code/product'
    }
  },
  myPage: '/mypage',
  admin: {
    list: '/admin',
    setting: '/admin/setting/{seq}'
  },
  sfsh: {
    monitoring: {
      icheon: {
        view: '/haccp/monitoring/icheon'
      },
      gunsan: {
        view: '/haccp/monitoring/gunsan'
      },
      productionResult: {
        list: '/haccp/monitoring/production/result',
        detail: '/haccp/monitoring/production/result/detail/{seq}'
      },
      rawMaterialResult: {
        list: '/haccp/monitoring/rawMaterial/result',
        detail: '/haccp/monitoring/rawMaterial/result/detail/{seq}'
      },
      processResult: {
        list: '/haccp/monitoring/process/result',
        detail: '/haccp/monitoring/process/result/detail/{seq}'
      },
      criticalLimit: {
        list: '/haccp/monitoring/criticalLimit',
        detail: '/haccp/monitoring/criticalLimit/detail/{seq}'
      },
      productionCcpMgmt: {
        list: '/haccp/monitoring/production/ccpManagement',
        detail: '/haccp/monitoring/production/ccpManagement/detail/{seq}'
      },
      rawMaterialCcpMgmt: {
        list: '/haccp/monitoring/rawMaterial/ccpManagement',
        detail: '/haccp/monitoring/rawMaterial/ccpManagement/detail/{seq}'
      },
      productionTodo: {
        list: '/haccp/monitoring/production/todo',
        detail: '/haccp/monitoring/production/todo/detail/{seq}'
      },
      rawMaterialTodo: {
        list: '/haccp/monitoring/rawMaterial/todo',
        detail: '/haccp/monitoring/rawMaterial/todo/detail/{seq}'
      },
      unRequested: {
        list: '/haccp/monitoring/production/unRequested',
        detail: '/haccp/monitoring/production/unRequested/detail/{seq}'
      }
    },
    inspectResult: {
      sample: {
        list: '/haccp/result/sample',
        detail: '/haccp/result/sample/detail/{seq}'
      },
      ingredient: {
        list: '/haccp/result/ingredient',
        detail: '/haccp/result/ingredient/detail/{seq}'
      },
      protein: {
        list: '/haccp/result/protein',
        detail: '/haccp/result/protein/detail/{seq}'
      },
      hygiene: {
        list: '/haccp/result/hygiene',
        detail: '/haccp/result/hygiene/detail/{seq}'
      }
    },
    motherShip: {
      list: '/haccp/mothershipInfo',
      detail: '/haccp/mothershipInfo/detail/{seq}'
    },
    report: {
      monthEndReport: {
        list: '/haccp/report/monthend',
        detail: '/haccp/report/monthend/detail/{seq}'
      },
      rawMaterial: {
        list: '/haccp/report/rawmaterial'
      },
      limitStandard: {
        list: '/haccp/report/limitstandard'
      },
      regularReview: {
        list: '/haccp/report/review'
      }
    },
    inspection: {
      inspectionSetting: {
        list: '/haccp/inspectionSetting',
        setting: '/haccp/inspectionSetting/detail/{seq}'
      },
      inspectionType: {
        list: '/haccp/inspectionType',
        setting: '/haccp/inspectionType/detail/{seq}'
      },
      inspectionGroup: {
        list: '/haccp/inspectionGroup',
        setting: '/haccp/inspectionGroup/detail/{seq}'
      },
      inspectionInfo: {
        list: '/haccp/inspectionInfo',
        setting: '/haccp/inspectionInfo/detail/{seq}'
      }
    },
    standard: {
      ingredient: {
        list: '/haccp/ingredient',
        setting: '/haccp/ingredient/detail/{seq}'
      },
      process: {
        list: '/haccp/processInfo',
        setting: '/haccp/processInfo/detail/{seq}'
      },
      employee: {
        list: '/haccp/employee',
        setting: '/haccp/employee/detail/{seq}'
      },
      productionInfo: {
        list: '/haccp/productionInfo',
        setting: '/haccp/productionInfo/detail/{seq}'
      },
      rawMaterialInfo: {
        list: '/haccp/rawMaterialInfo',
        setting: '/haccp/rawMaterialInfo/detail/{seq}'
      }
    }
  }
};

// 라우터 이름
const ROUTER_NAME = {
  sfms: {
    dashboard: {
      parent: 'dashboard',
      main: 'dashboardMain',
      trend: 'dashboardTrend'
    },
    rawMaterial: {
      price: 'rawMaterialPrice',
      nutrition: 'rawMaterialNutrition'
    },
    product: {
      output: 'productOutput',
      nutrition: 'productNutrition'
    },
    mix: {
      inform: 'mixInform',
      insert: 'mixInsert',
      output: 'mixOutput',
      ratio: 'mix'
    },
    monitoring: 'monitoring',
    report: {
      parent: 'report',
      mix: {
        plan: 'reportMixPlan',
        compare: 'reportMixCompare'
      },
      price: {
        rawMaterial: 'reportPriceRawMaterial',
        product: 'reportPriceProduct',
        prediction: 'reportPricePrediction'
      },
      iomc: 'reportIOMC',
      analysis: {
        product: 'reportAnalysisProduct',
        quality: 'reportAnalysisQuality'
      }
    }
  },
  board: {
    parent: 'board',
    notice: 'boardNotice',
    rawMaterial: 'boardRawMaterial',
    file: 'boardFile',
    qna: 'boardQnA'
  },
  standard: {
    parent: 'standard',
    code: {
      default: 'standardCode',
      mix: 'mixCd',
      rawMaterial: 'rwmtrCd',
      product: 'prdtCd'
    }
  },
  admin: {
    parent: 'admin',
    children: 'adminMember'
  },
  myPage: 'myPage'
};

const STYLE = {
  link: {
    color: 'var(--falcon-primary)',
    cursor: 'pointer',
    textDecoration: 'underline'
  }
};

// 국내 BU 코드
const KOREA_BU = 'K';

export {
  RESPONSE,
  RESPONSE_CODE,
  API_URL,
  TOKEN,
  ROUTER_PATH,
  ROUTER_NAME,
  STYLE,
  KOREA_BU
};
